import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import WorkspaceLoadingScreen from '../../components/loading/workspace/WorkspaceLoadingScreen';

/**
 * Requires an authenticated user with `users/{uid}.isSpecialAdmin === true`.
 */
const SpecialAdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <WorkspaceLoadingScreen message="Checking access…" />;
  }

  if (!user?.isSpecialAdmin) {
    return <Navigate to="/app/unauthorized" replace />;
  }

  return children;
};

export default SpecialAdminRoute;
